import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import {
  useAddFavoriteMutation,
  useAuthUserWithFavoritesQuery,
  useDeleteFavoriteMutation,
  useNotification,
} from "@/hooks";
import styles from "@/styles/Button.module.scss";
import classnames from "classnames";
import { useCallback, useEffect, useState } from "react";
import IconFav from "../../svgs/icon_fav_stroke.svg";

export default function FavoriteButton(props) {
  const { metaId, text, className, favBtn, ...buttonProps } = props;
  const { showNotification } = useNotification();
  const [favoriteOn, setFavoriteOn] = useState(false);
  const [addFavorite] = useAddFavoriteMutation({
    onCompleted: ({ addFavorite }) => {
      if (addFavorite.result) {
        showNotification("お気に入りに登録しました");
        setFavoriteOn(true);
      }
    },
    update: (cache) => {
      cache.evict({ fieldName: "favoritesByContentType" });
      cache.gc();
    },
  });
  const [deleteFavorite] = useDeleteFavoriteMutation({
    onCompleted: ({ deleteFavorite }) => {
      if (deleteFavorite.result) {
        showNotification("お気に入りから削除しました");
        setFavoriteOn(false);
      }
    },
    update: (cache) => {
      cache.evict({ fieldName: "favoritesByContentType" });
      cache.gc();
    },
  });
  const { data } = useAuthUserWithFavoritesQuery({
    fetchPolicy: "cache-first",
  });
  const user = data?.user;
  const favorites = data?.favorites;

  const handleClick = useCallback(
    (e) => {
      e?.preventDefault();
      e?.stopPropagation();
      if (favoriteOn) {
        deleteFavorite({ variables: { id: parseInt(metaId, 10) } });
      } else {
        addFavorite({ variables: { id: parseInt(metaId, 10) } });
      }
    },
    [favoriteOn]
  );

  useEffect(() => {
    let mounted = true;
    if (user) {
      const fav = !!favorites.metas.find((meta) => meta?.id === metaId);
      if (mounted) {
        setFavoriteOn(fav);
      }
    }
    return () => {
      mounted = false;
    };
  }, [user, favorites]);

  if (!user) return null;

  return (
    <ButtonMultiClick
      title="お気に入り"
      {...buttonProps}
      favBtn
      withIcon
      favBtnWithLabel={!!text}
      className={className}
      onClick={handleClick}
    >
      <span
        className={classnames(styles.icon, {
          [styles.favoriteOn]: favoriteOn,
        })}
      >
        <IconFav />
      </span>
      {text && <span className={styles.text}>{text}</span>}
    </ButtonMultiClick>
  );
}
